import {Box, LinearProgress, Tooltip, Typography} from '@mui/material';
import {env} from '../../config/env';

interface CourseCategoryTopicCardHeaderProgressProps {
  score: number;
}

const getScoreColor = (score: number): string => {
  const threshold = Math.floor(score);
  const index = Math.min(threshold, env.score.length - 1);
  return env.score[index]?.color || env.score[env.score.length - 1]?.color || '#2196F3';
};

export default function CourseCategoryTopicCardHeaderProgress({score}: CourseCategoryTopicCardHeaderProgressProps) {
  const color = getScoreColor(score);
  const integerPart = Math.floor(score);
  // Calculate decimal part for the progress bar (0-100% within the current level)
  const decimalPart = score - integerPart;
  const decimalPercentage = (decimalPart / 1) * 100;

  return (
    <Tooltip title={`Score: ${score.toFixed(1)}`} arrow>
      <Box
        sx={{display: 'flex', alignItems: 'center', gap: 1, width: '100%'}}
        data-testid="course-topic-score-progress"
      >
        <Box sx={{minWidth: 40}}>
          <Typography variant="body2" sx={{fontWeight: 600, color}} data-testid="course-topic-score-progress-value">
            {integerPart}
          </Typography>
        </Box>
        <Box sx={{flex: 1}}>
          <LinearProgress
            variant="determinate"
            value={decimalPercentage}
            data-testid="course-topic-score-progress-bar"
            sx={{
              height: 8,
              borderRadius: 1,
              bgcolor: 'grey.200',
              '& .MuiLinearProgress-bar': {
                borderRadius: 1,
                bgcolor: color,
              },
            }}
          />
        </Box>
      </Box>
    </Tooltip>
  );
}
